<template>
    <section class="d-flex flex-column h-full">
        <!-- <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar> -->
    <header class="mdc-top-app-bar top-app-bar top-header">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
<!--                <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"-->
<!--                    aria-label="Open navigation menu">menu</button>-->
                <span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{bradName}}</span>
            </section>
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                <div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click.prevent="login" @keypress.prevent="login" tabindex="0">LOGIN</div>
            </section>
        </div>
    </header>
    	<div class="d-flex h-full flex-column">
            <main class="main-wrapper full flex-grow-1 scroll-y">
                <router-view></router-view>
            </main>
        </div>
        <!-- <div class="flex-grow-1 scroll-y">
            <div class="pda-default">
                <div class="t-headline9">
                    {{$t('364')}}
                </div>
                <router-view></router-view>
            </div>
        </div> -->
    </section>

</template>

<script>
/**
 * 비밀번호 찾기 메인 컴포넌트(find password main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
    name: 'findpw',
    data() {
        return {
            bradName : localStorage.getItem('brandName'),
        }
    },
    components: {
        TopAppBar
    },

    watch: {
        '$route' (to, from) {
            if (to.name === 'FindPwStep1') {
                this.setTopAppBarCloseOnly('')
            }else {
                this.setTopAppBarBackOnly('')
            }
        }
    },

    mixins: [topAppBarMixin],

    mounted() {
       // this.setTopAppBarCloseOnly('')
       window.mdc.autoInit();
        const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set, .mdc-text-field';
        const buttonRipple = [].map.call(document.querySelectorAll(selector), function (el) {
            mdc.ripple.MDCRipple.attachTo(el);
        })
        if(document.querySelector('.mdc-tab-bar')){
            var tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));
        }
        if(document.querySelector('.mdc-text-field')){
            var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
        }
    },
    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        login(){
			this.$router.push('/login')
		}
    }
}
</script>
